import React, { Suspense } from 'react';

import { Onboarding as OnboardingView } from '@modules/Onboarding/views/Onboarding';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const Onboarding: React.FC = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <OnboardingView/>
      </Suspense>
    </ErrorBoundary>
  );
};
